/** Participant document lookup copy for delivery-point forms (domain; no infrastructure imports). */
export const PUNTOS_ENTREGA_PARTICIPANTE_BUSQUEDA = {
  notFound: 'No se encontró un participante con ese documento o nombre.',
  ambiguous:
    'Hay varias coincidencias con ese nombre. Escriba más caracteres o use el documento.',
} as const;
